import { useSellerPageContext } from "../../context-state/SellerPageContext.jsx";
import useResponsive from "../../hooks/minimal/useResponsive.jsx";
import { Stack, Card } from '@mui/material'
import Image from "../../components/minimal/image/index.jsx";
import { isEmbedMode } from "../../utils/iframe";
import { useState } from "react";
import { EntranceCodeDialog } from "../../components/minimal/EntranceCodeDialog";


const SellerJumbotron = () => {
    const { accountContext, endUserContext } = useSellerPageContext()
    const { account } = accountContext
    const { endUser, purchasedSubscriptions } = endUserContext
    const isMobile = useResponsive('down', 'sm');
    const [isQRDialogOpen, setIsQRDialogOpen] = useState(false);

    const hasActiveSubscriptions = purchasedSubscriptions?.length > 0;
    const seller = account?.parent || account;

    // Detect touch devices (phones, tablets, iPads)
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Hide jumbotron in embed mode
    if (isEmbedMode()) {
        return null;
    }

    if (!account) {
        return null
    }

    let { design } = account
    design = design ? design : {}
    const backgroundImageOverlay = design.sellerPageBackgroundImageOverlay ? `linear-gradient(${design.sellerPageBackgroundImageOverlay}, ${design.sellerPageBackgroundImageOverlay})` : "linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3))"

    const handleOpenQRDialog = () => {
        if (hasActiveSubscriptions) {
            setIsQRDialogOpen(true);
        }
    };

    const handleCloseQRDialog = () => {
        setIsQRDialogOpen(false);
    };

    return (
        <>
            <Stack
                sx={{
                    height: isMobile ? "40vh" : "50vh",
                    position: "relative",
                    width: "100%",
                    backgroundImage: `${backgroundImageOverlay}, url(${isMobile && design.imageBGMobile ? design.imageBGMobile : design.backgroundImage})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    cursor: hasActiveSubscriptions ? 'pointer' : 'default'
                }}
                onClick={isTouchDevice ? handleOpenQRDialog : undefined}
                onDoubleClick={!isTouchDevice ? handleOpenQRDialog : undefined}
            >
                <Stack
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    }}
                >
                    {design.profileImage && !design.profileImageIsLogo && <Card
                        sx={{
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            '&:hover': hasActiveSubscriptions ? { opacity: 0.8 } : {},
                            transition: 'opacity 0.2s'
                        }}
                    >
                        <Image
                            disabledEffect={true}
                            sx={{
                                width: isMobile ? "120px" : "200px",
                                height: isMobile ? "120px" : "200px",
                                borderRadius: "50%"
                            }}
                            src={design.profileImage}
                        />
                    </Card>}
                </Stack>
            </Stack>

            {/* QR Dialog for profile image double-click */}
            {hasActiveSubscriptions && (
                <EntranceCodeDialog
                    open={isQRDialogOpen}
                    onClose={handleCloseQRDialog}
                    subscription={purchasedSubscriptions[0]}
                    sellerId={seller?._id}
                    endUser={endUser}
                />
            )}
        </>
    )
}

export default SellerJumbotron